module.exports = __webpack_public_path__ + "assets/img/tit.c292be13.png";